import React, { FunctionComponent } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { TRANSLATION_NAMESPACE } from 'directory/listings/notification-modals/constants';
import { SingleDataCellProps } from 'directory/listings/notification-modals/types';
import 'directory/listings/notification-modals/components/TableCells/TableCells.scss';

export const SingleDataCell: FunctionComponent<SingleDataCellProps> = ({ data, isMissing = false, icon }) => {
    const { t } = useTranslation(TRANSLATION_NAMESPACE);

    return (
        <div className={classNames('single-data-cell', { 'single-data-cell--missing': isMissing })}>
            {isMissing ? (
                <>
                    <i className="icon-exclamation-circle mr-2 single-data-cell__icon--warning" />
                    <span>{t('MISSING_DATA')}</span>
                </>
            ) : (
                <>
                    {icon && <i className={`${icon} mr-2 single-data-cell__icon--info`} />}
                    <span>{data || '—'}</span>
                </>
            )}
        </div>
    );
};
